<template>
  <footer class="footer">
    <div class="content has-text-centered">
      <p>
        <strong>ShapeLog®</strong> is a registered trademark. Copyright 2016-18 ShapeLog, Inc.<br>
        210 E. Huron St., Ann Arbor, MI 48104<br>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  created() {
    // console.log('Footer: created()...');
  },
};
</script>

<style scoped lang="scss">

</style>
